import { Injectable } from '@angular/core';
import { User } from '../model/user';

@Injectable()
export class UserProvider {

	/** Aktueller User. */
	user: User = <any>{};

	constructor() {
		//User aus Local Storage laden
		if (localStorage.getItem("username")) {
			this.user = {
				username: localStorage.getItem("username"),
				password: localStorage.getItem("password")
			};
		}
	}

	/**
	 * Gibt true zurück, gdw. Username und Passwort gesetzt sind.
	 */
	isLoggedIn() : boolean {
		return (this.user.username != null) && (this.user.username.length > 0) &&
			(this.user.password != null);
	}

	/**
	 * Meldet den Benutzer mit den gegebenen Benutzerdaten an
	 * und speichert die Zugangsdaten im Local Storage.
	 */
	login(username: string, password: string) : void {
		let p = this.cleanPassword(password);
		this.user = { username: username, password: p };
		localStorage.setItem("username", username);
		localStorage.setItem("password", p);
	}

	logout() : void {
		this.user = <any>{};
		localStorage.removeItem("username");
		localStorage.removeItem("password");
	}

	/**
	 * Meldet den Benutzer aus der gegebenen URL
	 * "ruhesanfteingabe://login/<username>/<password>" an,
	 * sofern die gegebene URL dieses Schema hat.
	 * Im Erfolgsfall wird true zurückgegeben.
	 */
	loginFromUrl(url: string) : boolean {
		let prefix = "ruhesanfteingabe://login/";
		if (url.startsWith(prefix)) {
			let s = url.substring(prefix.length).split("/");
			if (s.length == 2) {
				this.login(s[0], s[1]);
				return true;
			}
		}
		return false;
	}

	/**
	 * Entfernt Leerzeichen aus dem gegebenen Passwort.
	 */
	cleanPassword(password: string) {
		return password.split(' ').join(''); //remove all " "
	}

	/**
	 * Überprüft Benutzername und Passwort. Es kann nicht überprüft werden, ob
	 * das Passwort ganz korrekt ist, weil sonst müsste hier der Algorithmus
	 * offengelegt werden (keine gute Idee in JavaScript auf Client-Seite).
	 * Stattdessen wird überprüft, ob die Prüfziffern für die Ziffern 1-5
	 * an Stelle 6-7 stimmen und die Prüfziffern für den Benutzername an
	 * Stelle 8-9.
	 */
	checkLogin(userid: string, password: string) : boolean {
		let p = this.cleanPassword(password);
		if (p.length != 9)
			return false;
		//überprüfe Prüfziffern 6-7
		let code = +(p.substring(0, 5));
		let checkCode = +(p.substring(5, 7));
		if (code % 97 != checkCode)
			return false;
		//überprüfe Prüfziffern 8-9
		let checkUser = 0;
		let userid64 = window.btoa(encodeURIComponent(userid));
	  for (let i = 0; i < userid64.length; i++) {
	    checkUser = checkUser + 7 * i * userid64.charCodeAt(i);
	  }
		let foundCheckUser = +(p.substring(7, 9));
	  if (checkUser % 97 != foundCheckUser)
			return false;
		return true;
	}

}



// WEBPACK FOOTER //
// ./src/providers/user.provider.ts